/* eslint-disable max-len */

// eslint-disable-next-line import/prefer-default-export
export const QUESTIONS = [
  {
    question: 'Что такое подписка?',
    answer: 'Подписка — это простой способ читать больше, практически без ограничений. Примером может служить абонентская плата за интернет или мобильную связь. Вам больше не нужно задумываться о покупке книг по одной, вы получаете доступ ко всему каталогу книг.',
  },
  {
    question: 'Какие устройства поддерживаются?',
    answer: 'На большинстве планшетов и смартфонов систем iOS версии выше 10, Android версии выше 4.1 в мобильном приложении MyBook, а также с компьютера на сайте. Не поддерживаем чтение в браузере IE до 11 версии.',
  },
  {
    question: 'Сколько книг я могу прочесть за месяц?',
    answer: 'Сколько сможете. Читайте столько, сколько захотите. Мы не ограничиваем вас в количестве книг.',
  },
  {
    question: 'Легальны ли книги в библиотеке MyBook? ',
    answer: 'Да, полностью. В каталог MyBook сейчас попадает вся коллекция изданий из книжного магазина ЛитРес, который заключает прямые договора с авторами и издательствами.',
  },
];
